module.exports = __webpack_public_path__ + "media/images/svg/undraw_select_house_qbag-5678431aa65613d697d27d4b3a1dec81.svg";